import { Routes } from '@angular/router';
import { authGuard } from '@guards/auth.guard';
import { hasPermissionsGuard } from '@guards/has-permissions.guard';
import { SemanasCotizadasPage } from './semanas-cotizadas/semanas-cotizadas.component';
import { VigenciaDerechoPage } from './vigencia-derecho/vigencia-derecho.component';
import { ConsultarNssPage } from './consultar-nss/consultar-nss.component';
import { InformacionNssPage } from './informacion-nss/informacion-nss.component';
import { NoDerechohabientePage } from './no-derechohabiente/no-derechohabiente.component';
import { AsignarCorreoNssPage } from './asignar-correo-nss/asignar-correo-nss.component';

let moduleName = 'imss';

export const imss: Routes = [
  {
    path: `${moduleName}/consultar-nss`,
    component: ConsultarNssPage,
    title: 'IMSS - Consultar NSS.',
    canActivate: [authGuard, hasPermissionsGuard(['imss_consultar_nss_access'])],
  },
  {
    path: `${moduleName}/informacion-nss`,
    component: InformacionNssPage,
    title: 'IMSS - Información NSS.',
    canActivate: [authGuard, hasPermissionsGuard(['imss_informacion_nss_access'])],
  },
  {
    path: `${moduleName}/asignar-correo-nss`,
    component: AsignarCorreoNssPage,
    title: 'IMSS - Asignar correo electrónico a NSS.',
    canActivate: [authGuard, hasPermissionsGuard(['imss_asignar_correo_nss_access'])],
  },
  {
    path: `${moduleName}/semanas-cotizadas`,
    component: SemanasCotizadasPage,
    title: 'IMSS - Semanas cotizadas.',
    canActivate: [authGuard, hasPermissionsGuard(['imss_semanas_cotizadas_access'])],
  },
  {
    path: `${moduleName}/vigencia-derecho`,
    component: VigenciaDerechoPage,
    title: 'IMSS - Vigencia de derecho.',
    canActivate: [authGuard, hasPermissionsGuard(['imss_vigencia_derecho_access'])],
  },
  {
    path: `${moduleName}/no-derechohabiente`,
    component: NoDerechohabientePage,
    title: 'IMSS - No derechohabiente.',
    canActivate: [authGuard, hasPermissionsGuard(['imss_no_derechohabiente_access'])],
  },
];
